import moment from 'moment-timezone';

type EventListItemProps = {
  startDate: string;
  spotsLeft: number;
  classes?: string;
  active?: boolean;
  testID?: string;
  index: string | number;
  onSelect: () => void;
};

export function EventListItem(props: EventListItemProps) {
  return (
    <div
      className={`shadow-lg shadow-stone rounded-md p-4 mb-5 hover:ring-2 hover:ring-ginger ${props?.classes} ${props?.active ? 'ring-ginger ring-2' : ''}`}
      onClick={props.onSelect}
      data-testid={props?.testID ?? 'event-list-item' + props.index}>
      <div className="uppercase font-roboto-mono text-sm">Starts {moment(props.startDate).format('MMM DD')}</div>
      <div className="font-bold">{`${moment(props.startDate).format('dddd')}s at ${moment(props.startDate).format('h:mm a')}`}</div>
      <div className={props.spotsLeft < 5 ? 'rounded-md bg-stone text-ginger text-sm p-2 w-fit mt-4' : 'rounded-md bg-stone text-sm p-2 w-fit mt-4'}>
        {props.spotsLeft} spots left
      </div>
    </div>
  );
}
